module.exports = __webpack_public_path__ + "img/phone-notifications.73305465.svg";